import { ENDPOINTS } from "../config/endpoints";

export const playerSchema = {
  steps: [
    {
      title: "Personal Information",
      fields: [
        // ZenMinds canonical player ID still ships in the API response
        // (server-generated, used for backend reconciliation + cross-system
        // joins) but is intentionally NOT rendered in the SPA — operators
        // don't need to see or copy it. Re-add this entry to surface it.
        { name: "ci_player_id", type: "text", displayName: "Cricinfo ID" },
        { name: "jersey_number", type: "text", displayName: "Jersey Number" },
        { name: "first_name", type: "text", displayName: "First Name", required: true },
        { name: "middle_name", type: "text", displayName: "Middle Name" },
        { name: "last_name", type: "text", displayName: "Last Name" },
        { name: "nick_name", type: "text", displayName: "Display Name" },
        {
          name: "nationality",
          type: "select",
          displayName: "Nationality",
          fetch: ENDPOINTS.coredata.nationalities,
        },
        {
          name: "state",
          type: "select",
          displayName: "State / UT",
          optionsKey: "INDIAN_STATES",
        },
        {
          name: "city",
          type: "text",
          displayName: "City / District",
        },
        {
          name: "date_of_birth",
          type: "text",
          inputType: "date",
          displayName: "Date of Birth",
        },
        {
          name: "gender",
          type: "select",
          displayName: "Gender",
          optionsKey: "GENDERS",
        },
        // moved bowling_types to Cricket Attributes
      ],
    },
    {
      title: "Contact & Career",
      fields: [
        { name: "email",       type: "text", inputType: "email", displayName: "Email" },
        { name: "mobile",      type: "text", inputType: "tel",   displayName: "Mobile" },
        { name: "whatsapp_ok", type: "boolean", displayName: "WhatsApp OK?" },
        {
          name: "debut_year_intl",
          type: "text",
          inputType: "number",
          displayName: "Intl Debut Year",
        },
        {
          name: "retirement_year_intl",
          type: "text",
          inputType: "number",
          displayName: "Intl Retirement Year",
        },
      ],
    },
    {
      title: "Physical Attributes",
      fields: [
        {
          name: "height_cm",
          type: "text",
          inputType: "number",
          displayName: "Height (cm)",
        },
        {
          name: "weight_kg",
          type: "text",
          inputType: "number",
          displayName: "Weight (kg)",
        },
      ],
    },
    {
      title: "Cricket Attributes",
      fields: [
        {
          name: "batting_hand",
          type: "select",
          displayName: "Batting Hand",
          optionsKey: "BATTING_HANDS",
        },
        {
          // Multi-select — ambidextrous bowlers can use both hands. The
          // backend syncs the legacy singular `bowling_hand` from
          // bowling_hands[0] automatically (Player.save), so every
          // downstream reader still sees a single primary hand.
          name: "bowling_hands",
          type: "multiselect",
          displayName: "Bowling Hand(s)",
          optionsKey: "BOWLING_HANDS",
        },
        {
          name: "role",
          type: "select",
          displayName: "Role",
          optionsKey: "PLAYER_ROLES",
        },
        {
          name: "bowling_type",
          type: "select",
          displayName: "Bowling Type",
          optionsKey: "BOWLING_TYPES",
        },
        {
          name: "bowling_types",
          type: "multiselect",
          displayName: "Bowling Types",
          optionsKey: "BOWLING_TYPES",
        },
        {
          name: "batting_type",
          type: "select",
          displayName: "Batting Type",
          optionsKey: "BATTING_TYPES",
        },
        // batting_style removed (free-text, low value) — replaced by structured
        // batting_type above.
        {
          name: "bowling_style",
          type: "select",
          displayName: "Bowling Style",
          optionsKey: "BOWLING_STYLES",
        },
        {
          // Teams the player represents. The endpoint /api/coredata/my-teams/
          // is tenant-scoped — B2C users see only teams they own; B2B users
          // see their org's teams + SYSTEM teams. Picks-from-list, never
          // exposes franchise/international teams to B2C scorers.
          name: "master_teams",
          type: "multiselect",
          displayName: "Teams represented",
          fetch: ENDPOINTS.coredata.teams,
        },
      ],
    },
  ],
};
